export default __webpack_public_path__ + "static/Introduction-to-CFM-Loop-360p-aeb0688e5d313f3f52564e347657a3ad.mp4";